module.exports = __webpack_public_path__ + "static/wintersense-csl-mounting-cropped.bdfdc2b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/TheSensor/wintersense-csl-mounting-cropped.jpg
// module id = 462
// module chunks = 72476233251319